module.exports = {
    colors:{

        primary:'#600606',
        secundary:'#a21706',
        accent:'#292626',
        danger:'#ec2a2a',


        panel1:'#a21706',
        panel2:'#2060d3',
        panel3:'#7414bf',
    }
  
}